module.exports = __webpack_public_path__ + "static/img/philosophy.4bf08f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceExperience/philosophy.png
// module id = eLIF
// module chunks = 1